export enum LogType {
  INFO = "info",
  ERROR = "error",
  DEBUG = "debug",
  WARN = "warn",
}
